<template>
    <div id="header-root" class="headerRoot">
        <div id="search-header-wrapper" class="searchHeaderWrapper">
            <div id="header-input-wrapper" class="headerInputWrapper">
                <div
                    id="header-logo"
                    class="headerLogo"
                    @click="goToHomepage()"
                >
                    <img
                        id="header-logo-img"
                        class="headerLogoImage"
                        :src="branding.logo"
                    />
                </div>
                <div
                    id="header-input-inner-wrapper"
                    class="headerInputInnerWrapper"
                    :class="isAutoFill ? 'autofill' : ''"
                    @removeAutoFill="removeAutoFill"
                    @addAutoFill="addAutoFill"
                >
                    <auto-complete-input
                        v-model="query"
                        ref="queryInput"
                        id="header-input"
                        class="headerInput"
                        :group="-1"
                        :placeholder="branding.AutocompletePlaceholder"
                        @selected="emitSearchEvent($event)"
                        @return="emitSearchEvent()"
                        @iconClick="emitSearchEvent()"
                    />
                </div>
            </div>
            <!-- reordered header -->
            <reordered-freshy-header
                v-if="$features('reordered-links')"
                @setCurrentMode="setCurrentMode"
                :query="query"
                :enteredQuery="enteredQuery"
            ></reordered-freshy-header>
            <div id="header-nav" v-else class="headerNav" v-show="!hideCat">
                <div
                    v-for="(navItem, index) in viewList"
                    :key="index"
                    :id="`nav_${navItem.name}`"
                    class="navItem"
                    :class="{
                        activeNavItem: isCurrentRoute(navItem.name),
                    }"
                    @click="setCurrentMode(navItem)"
                >
                    <router-link
                        v-if="currentMode"
                        :id="`nav-link_${navItem.name}`"
                        class="navLink"
                        :to="{
                            name: navItem.name,
                            query: queryParameters,
                        }"
                        @click="currentMode.name = navItem.name"
                    >
                        <img
                            :id="`nav-icon_${navItem.name}`"
                            class="navIcon"
                            :src="navItem.icon"
                        />{{ navItem.name || "Web" }}</router-link
                    >

                    <a
                        v-if="!currentMode"
                        :id="`nav-link_${navItem.name}`"
                        class="navLink"
                        :href="`${navItem.path.substring(1)}${querySearch}`"
                        @click="currentMode.name = navItem.name"
                    >
                        <img
                            :id="`nav-icon_${navItem.name}`"
                            class="navIcon"
                            :src="navItem.icon"
                        />{{ navItem.name }}</a
                    >
                </div>
                <div class="navItem yah">
                    <a
                        id="nav-link_images"
                        class="navLink"
                        :href="
                            `https://images.search.yahoo.com/yhs/search?p=${
                                enteredQuery ? enteredQuery : ''
                            }&type=${typeTag}`
                        "
                        target="_blank"
                        @click="trackGA('click', { label: 'images' })"
                    >
                        <img
                            id="nav-link_Images"
                            src="/assets/images/common/icon_images.svg"
                        />
                        Images</a
                    >
                </div>

                <div class="navItem yah">
                    <a
                        id="nav-link_video"
                        class="navLink"
                        :href="
                            `https://video.search.yahoo.com/yhs/search?p=${
                                enteredQuery ? enteredQuery : ''
                            }&type=${typeTag}`
                        "
                        target="_blank"
                        @click="trackGA('click', { label: 'video' })"
                    >
                        <img
                            id="nav-link_Video"
                            class="navLink"
                            src="/assets/images/common/icon_video.svg"
                        />
                        Video</a
                    >
                </div>

                <div class="navItem yah">
                    <a
                        id="nav-link_shopping"
                        class="navLink"
                        :href="
                            `https://shopping.yahoo.com/search?p=${
                                enteredQuery ? enteredQuery : ''
                            }&type=${typeTag}`
                        "
                        target="_blank"
                        @click="trackGA('click', { label: 'shopping' })"
                    >
                        <img
                            id="nav-link_Shopping"
                            class="navLink"
                            src="/assets/images/common/icon_shopping.svg"
                        />
                        Shopping</a
                    >
                </div>

                <div class="navItem yah">
                    <a
                        id="nav-link_news"
                        class="navLink"
                        :href="
                            `https://news.search.yahoo.com/search?p=${
                                enteredQuery ? enteredQuery : ''
                            }&type=${typeTag}`
                        "
                        target="_blank"
                        @click="trackGA('click', { label: 'news' })"
                    >
                        <img
                            id="nav-link_News"
                            class="navLink"
                            src="/assets/images/common/icon_news.svg"
                        />
                        News</a
                    >
                </div>

                <div id="yahoo-links-more" class="navItem more dropdown">
                    <a id="nav-link_more" class="navLink dropbtn" href="#">
                        <img
                            id="nav-link_More"
                            class="navLink"
                            src="/assets/images/common/icon_more.svg"
                        />
                        More</a
                    >
                    <div class="dropdown-content">
                        <a
                            @click="trackGA('click', { label: 'images' })"
                            :href="
                                `https://images.search.yahoo.com/yhs/search?p=${
                                    enteredQuery ? enteredQuery : ''
                                }&type=${typeTag}`
                            "
                            target="_blank"
                            ><img
                                class="moreLink"
                                src="/assets/images/common/icon_images.svg"
                            />Images</a
                        >
                        <a
                            @click="trackGA('click', { label: 'video' })"
                            :href="
                                `https://video.search.yahoo.com/yhs/search?p=${
                                    enteredQuery ? enteredQuery : ''
                                }&type=${typeTag}`
                            "
                            target="_blank"
                            ><img
                                class="moreLink"
                                src="/assets/images/common/icon_video.svg"
                            />Videos</a
                        >
                        <a
                            @click="trackGA('click', { label: 'shopping' })"
                            :href="
                                `https://shopping.yahoo.com/search?p=${
                                    enteredQuery ? enteredQuery : ''
                                }&type=${typeTag}`
                            "
                            target="_blank"
                            ><img
                                class="moreLink"
                                src="/assets/images/common/icon_shopping.svg"
                            />Shopping</a
                        >
                        <a
                            @click="trackGA('click', { label: 'news' })"
                            :href="
                                `https://news.search.yahoo.com/search?p=${
                                    enteredQuery ? enteredQuery : ''
                                }&type=${typeTag}`
                            "
                            target="_blank"
                            ><img
                                class="moreLink"
                                src="/assets/images/common/icon_news.svg"
                            />News</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import queryString from "query-string";
import { documentReady, getTypeTag, setSearchHistory } from "@/common";
import { verticalList, defaultVertical } from "@/linkLists";
import { pageviewEvent, searchEvent, trackGA } from "@/analytics";
import { getBranding } from "@/branding";
import AutoCompleteInput from "@/components/autoCompleteInput/AutoCompleteInput.vue";
import ReorderedHeader from "./ReorderedHeader.vue";
import { COBRAND_URL } from "@/urls";

export default {
    name: "freshy-header",
    props: ["groupNum"],
    components: {
        "auto-complete-input": AutoCompleteInput,
        "reordered-freshy-header": ReorderedHeader,
    },
    data() {
        const qs = queryString.parse(window.location.search);
        return {
            query: qs.q || null,
            typeTag: qs.type || null,
            enteredQuery: qs.q || null,
            routerKey: 0,
            viewList: verticalList,
            branding: getBranding(),
            currentMode: this.$route,
            isAutoFill: false,
            hideCat: false,
            trackGA,
        };
    },
    mounted() {
        document.querySelector("#header-input").focus();
        // Possible pageview call here

        documentReady.then(() => {
            // check for typetag and fix if necessary
            if (this.typeTag) {
                this.typeTag = getTypeTag(this.typeTag, true);
            }
        });
        document.addEventListener(
            "scroll",
            e => {
                const path = this.currentMode ? this.currentMode.name : "Web";
                if (e.target) {
                    const scrollTop = e.target.scrollTop
                        ? e.target.scrollTop
                        : (document.documentElement &&
                              document.documentElement.scrollTop) ||
                          document.body.scrollTop;
                    if (scrollTop == 0) {
                        this.hideCat = false;
                    } else if (path === "Web" && scrollTop > 75) {
                        this.hideCat = true;
                    } else if (path !== "Web" && scrollTop > 30) {
                        this.hideCat = true;
                    }
                }
            },
            true
        );
    },
    computed: {
        queryParameters() {
            const qs = queryString.parse(window.location.search);
            if (!this.$features("cobrand")) {
                if (this.query) qs.q = this.query;
            }
            if (this.typeTag) qs.type = this.typeTag;
            if (this.guid) qs.guid = this.guid;
            return qs;
        },
        querySearch() {
            return window.location.search;
        },
    },
    methods: {
        removeAutoFill() {
            this.isAutoFill = false;
        },
        addAutoFill() {
            this.isAutoFill = true;
        },
        isCurrentRoute(routeName) {
            if (this.$route) return this.$route.name == routeName;
            return routeName == "Web";
        },
        setCurrentMode(navItem) {
            this.currentMode = navItem;
            trackGA("click", { label: this.currentMode.name });
        },
        goToHomepage() {
            let params = "";
            if (window.location.search) {
                const searchParams = new URLSearchParams(
                    window.location.search
                );
                searchParams.delete("q");
                if (Array.from(searchParams).length > 0)
                    params = `?${searchParams.toString()}`;
            }
            window.location.href = `/${params}`;
        },
        emitSearchEvent(type) {
            const url = new URL(window.location.href);
            if (
                this.$features("cobrand") &&
                window.location.pathname === "/web"
            ) {
                return window.open(
                    COBRAND_URL(this.query, this.typeTag),
                    "_blank"
                );
            }
            if (this.query) url.searchParams.set("q", this.query);
            else url.searchParams.delete("q");
            const title = `Freshy Web Search - ${this.query}`;
            document.title = title;
            window.history.replaceState(
                { path: url.toString() },
                `Freshy Web Search - ${this.query}`,
                url.toString()
            );
            const mode = this.currentMode ? this.currentMode.name : "Web";
            searchEvent(this.query, mode, this.typeTag);
            this.$emit("search", type);

            setSearchHistory(this.query, mode);
            this.$refs.queryInput.updateSearcHistory();

            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
    },
};
</script>

<style>
@import "./header.css";
</style>
